"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var PollOverrideRestoreStrategyBuilder = /** @class */ (function () {
    function PollOverrideRestoreStrategyBuilder() {
    }
    PollOverrideRestoreStrategyBuilder.prototype.withNs = function (ns) {
        this.ns = ns;
        return this;
    };
    PollOverrideRestoreStrategyBuilder.prototype.withChannelName = function (channelName) {
        this.channelName = channelName;
        return this;
    };
    PollOverrideRestoreStrategyBuilder.prototype.withRestoreStrategy = function (strategy) {
        this.restore = strategy;
        return this;
    };
    PollOverrideRestoreStrategyBuilder.prototype.build = function () {
        return {
            ns: this.ns,
            channel: this.channelName,
            override: this.restore,
        };
    };
    return PollOverrideRestoreStrategyBuilder;
}());
exports.default = PollOverrideRestoreStrategyBuilder;
//# sourceMappingURL=PollOverrideRestoreStrategyBuilder.js.map